import { Checkbox, Select } from 'antd'
import type { HookAPI } from 'antd/es/modal/useModal'

import type { OrganisationShortType } from '@/types'

import SelectNotFound from './SelectNotFound'
import cn from './SubscriptionCreationModal.module.scss'
import useOrganisationSearch from './useOrganisationSearch'

type SubscriptionClientFilterProps = {
  modal: HookAPI
  allMyClients: boolean
  onAllMyClientsChange: (allMyClients: boolean) => void
  selectedClients: OrganisationShortType[]
  onSelectedClientsChange: (clients: OrganisationShortType[]) => void
}

function SubscriptionClientFilter({
  modal,
  allMyClients,
  onAllMyClientsChange,
  selectedClients,
  onSelectedClientsChange,
}: SubscriptionClientFilterProps) {
  const clientSearch = useOrganisationSearch(modal)

  const isSelected = (id: string) =>
    selectedClients.some((client) => client.id === id)

  const addClient = (id: string) => {
    const option = clientSearch.options.find((item) => item.value === id)
    if (option && !isSelected(id)) {
      onSelectedClientsChange([...selectedClients, option.org])
    }
    clientSearch.resetQuery()
  }

  const removeClient = (id: string) =>
    onSelectedClientsChange(
      selectedClients.filter((client) => client.id !== id)
    )

  return (
    <section className={cn.section}>
      <h3 className={cn.sectionTitle}>3. Фильтр клиентов</h3>
      <Checkbox
        checked={allMyClients}
        onChange={(e) => {
          onAllMyClientsChange(e.target.checked)
          if (e.target.checked) onSelectedClientsChange([])
        }}
      >
        Применять для всех моих клиентов
      </Checkbox>

      {!allMyClients && (
        <>
          <Select
            showSearch
            filterOption={false}
            placeholder="Поиск организации..."
            value={null}
            searchValue={clientSearch.searchValue}
            onSearch={clientSearch.handleSearch}
            onOpenChange={clientSearch.handleOpenChange}
            onPopupScroll={clientSearch.handlePopupScroll}
            loading={clientSearch.loading}
            onChange={addClient}
            options={clientSearch.options.filter(
              (option) => !isSelected(option.value)
            )}
            notFoundContent={<SelectNotFound loading={clientSearch.loading} />}
            className={cn.fullWidth}
          />
          {selectedClients.length > 0 && (
            <div className={cn.chips}>
              {selectedClients.map((client) => (
                <span key={client.id} className={cn.chip}>
                  {client.description}
                  <button
                    type="button"
                    className={cn.chipRemove}
                    onClick={() => removeClient(client.id)}
                  >
                    ×
                  </button>
                </span>
              ))}
            </div>
          )}
        </>
      )}
    </section>
  )
}

export default SubscriptionClientFilter
